import { __name } from './chunk-Q72B4Q5Z.mjs';

// src/errors.ts
var UserError = class extends Error {
  static {
    __name(this, "UserError");
  }
  telemetryMessage;
  constructor(message, options) {
    super(message, options);
    Object.setPrototypeOf(this, new.target.prototype);
    this.telemetryMessage = typeof options?.telemetryMessage === "string" ? options.telemetryMessage : options?.telemetryMessage ? message : void 0;
  }
};
var DeprecationError = class extends UserError {
  static {
    __name(this, "DeprecationError");
  }
  constructor(message, options) {
    super(`Deprecation:
${message}`, options);
  }
};
var FatalError = class extends UserError {
  static {
    __name(this, "FatalError");
  }
  code;
  constructor(message, options) {
    super(message, options);
    this.code = options.code;
  }
};
var CommandLineArgsError = class extends UserError {
  static {
    __name(this, "CommandLineArgsError");
  }
};
var JsonFriendlyFatalError = class extends FatalError {
  static {
    __name(this, "JsonFriendlyFatalError");
  }
};
var MissingConfigError = class extends Error {
  static {
    __name(this, "MissingConfigError");
  }
  telemetryMessage;
  constructor(key) {
    super(`Missing config value for ${key}`);
    this.telemetryMessage = `Missing config value for ${key}`;
  }
};
function createFatalError(message, isJson, options) {
  if (isJson) {
    return new JsonFriendlyFatalError(JSON.stringify(message), options);
  }
  return new FatalError(`${message}`, options);
}
__name(createFatalError, "createFatalError");

export { CommandLineArgsError, DeprecationError, FatalError, JsonFriendlyFatalError, MissingConfigError, UserError, createFatalError };
